<div
  class="flex flex-row items-center py-3 soft-card shadow rounded flex-nowrap cursor-pointer"
  (click)="goToApplication(application)"
>
  <span
    class="application-icon rounded-md min-w-16 min-h-16 text-center items-center content-center mt-1 justify-center"
    [class]="application?.color ?? 'bg-surface-tertiary text-color'"
  >
    <i
      *ngIf="application?.icon !== ''; else defaultIcon"
      [class]="application?.icon"
      class="fa-2x"
    ></i>
  </span>
  <div class="flex flex-col w-full ml-3">
    <span class="font-bold text-xl">{{ application?.name | translate }}</span>
    <p class="color-light" *ngIf="application?.description">
      {{ application?.description | translate }}
    </p>
  </div>
  <div class="flex flex-col justify-center items-center p-2">
    @if (application?.type === 'link') {
      <soft-icon
        name="fa-regular fa-arrow-up-right-from-square"
        class="text-sm color-lighter"
      ></soft-icon>
    } @else {
      <i class="fa-regular fa-chevron-right color-lighter"></i>
    }
  </div>
</div>

<ng-template #defaultIcon>
  <i class="fa-regular fa-ban fa-3x"></i>
</ng-template>
